import { render, staticRenderFns } from "./ed-deck-item.component.vue?vue&type=template&id=1cbf4f71&scoped=true&"
import script from "./ed-deck-item.component.ts?vue&type=script&lang=ts&"
export * from "./ed-deck-item.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-deck-item.component.scss?vue&type=style&index=0&id=1cbf4f71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbf4f71",
  null
  
)

export default component.exports